export default __webpack_public_path__ + "static/media/prob_solving.73e326b8.svg";